module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonecvm-intro-card1.2@2x.6ac81710.jpg";